import Vue from 'vue'
import Vuex from 'vuex'
import globals from './modules/globals'
import firebase from './modules/firebase'
import { vuexfireMutations } from 'vuexfire'


Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		firebase,
		globals
	},
	mutations: vuexfireMutations
})